// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"361":"d5ca3e6e02a854187809","438":"ff6dae0d169afeca53e2","488":"36969b733e1305353de7","547":"b69e00b22bbe48f1ddf3","563":"fc81c9a3a1fc57f0eace","755":"0e58a89c564af39c21a4"}[chunkId] + ".js";
};